<template>
  <header class="header">
    <div class="container">
      <div class="nav-wrapper">
        <div class="logo">
          <img :src="$config.header.logo_image" :alt="$config.header.brand" class="logo-img">
          <span class="logo-text">{{ $config.header.brand }}</span>
        </div>
        
        <!-- 移动端汉堡菜单按钮 -->
        <button class="mobile-menu-btn" @click="toggleMobileMenu" :class="{ active: isMobileMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <!-- 桌面端导航 -->
        <div class="nav-container" :class="{ 'mobile-open': isMobileMenuOpen }">
          <nav class="nav">
            <router-link to="/" class="nav-link" @click="closeMobileMenu">{{ $config.header.home }}</router-link>
            <a :href="$config.header.links.install_guide_url" class="nav-link" target="_blank" rel="noopener noreferrer" @click="closeMobileMenu">{{ $config.header.install_guide }}</a>
            <a :href="$config.header.links.usage_guide_url" class="nav-link" target="_blank" rel="noopener noreferrer" @click="closeMobileMenu">{{ $config.header.usage_guide }}</a>
            <a :href="$config.header.links.update_guide_url" class="nav-link" target="_blank" rel="noopener noreferrer" @click="closeMobileMenu">{{ $config.header.update_guide }}</a>
            <a href="#contact-us" class="nav-link" @click="scrollToContact">{{ $config.header.contact_us }}</a>
            <router-link to="/download" class="nav-link" @click="closeMobileMenu">{{ $config.header.download_app }}</router-link>
          </nav>
        </div>
        
        <!-- 登录状态/个人中心 -->
        <div v-if="userInfo" class="user-profile" v-click-outside="closeUserMenu">
          <div class="avatar" @click="toggleUserMenu">
            {{ avatarLetter }}
          </div>
          
          <div class="user-menu" v-if="isUserMenuOpen">
            <!-- Header section -->
            <div class="menu-header">
              <span class="menu-label">当前用户</span>
              <span class="user-code">{{ userInfo.share_code || 'N/A' }}</span>
            </div>
            
            <!-- Menu items -->
            <div class="menu-item" @click="handleViewHistory">
              <div class="menu-icon-wrapper">
                <img class="menu-icon" :src="historyIcon" alt="">
              </div>
              <div class="menu-item-content">
                <span class="menu-item-title">阅卷历史</span>
                <span class="menu-item-sub">查看过往考试记录</span>
              </div>
            </div>
            
            <div class="menu-item" @click="handleLogout">
              <div class="menu-icon-wrapper">
                <img class="menu-icon" :src="logoutIcon" alt="">
              </div>
              <span class="menu-item-title">登出账号</span>
            </div>
          </div>
        </div>

        <!-- 登录按钮 (未登录时显示) -->
        <button v-else class="login-btn" @click="toggleLoginModal">
          <img src="/images/icon_history.png" alt="阅卷历史" class="login-icon">
          <span class="login-text">阅卷历史</span>
        </button>
      </div>
    </div>
    
    <!-- 登录二维码弹窗 -->
    <div class="login-modal" v-if="isLoginModalOpen" @click.self="closeLoginModal">
      <div class="login-modal-container" @click.self="closeLoginModal">
        <div class="login-modal-content" @click.stop>
          <div class="modal-header">
            <div class="modal-logo">
              <img :src="$config.header.logo_image" :alt="$config.header.brand" class="modal-logo-img">
              <span class="modal-brand">{{ $config.header.brand }}</span>
            </div>
          </div>
          <div class="modal-body">
            <ScanLogin @success="handleLoginSuccess" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import ScanLogin from './ScanLogin.vue'

export default {
  name: 'Header',
  components: {
    ScanLogin
  },
  data() {
    return {
      isMobileMenuOpen: false,
      isLoginModalOpen: false,
      isUserMenuOpen: false,
      userInfo: null,
      // Menu icons from design
      historyIcon: '/images/history.png',
      logoutIcon: '/images/logout.png'
    }
  },
  computed: {
    avatarLetter() {
      if (this.userInfo && this.userInfo.share_code) {
        return this.userInfo.share_code.charAt(0).toUpperCase()
      }
      return 'U'
    }
  },
  directives: {
    'click-outside': {
      mounted(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unmounted(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    },
    scrollToContact(event) {
      event.preventDefault()
      this.closeMobileMenu()
      const element = document.getElementById('contact-us')
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    toggleLoginModal() {
      this.isLoginModalOpen = !this.isLoginModalOpen
    },
    closeLoginModal() {
      this.isLoginModalOpen = false
    },
    handleLoginSuccess(tokenData) {
      console.log('Login success:', tokenData)
      this.userInfo = tokenData
      this.closeLoginModal()
    },
    toggleUserMenu() {
      this.isUserMenuOpen = !this.isUserMenuOpen
    },
    closeUserMenu() {
      this.isUserMenuOpen = false
    },
    handleLogout() {
      localStorage.removeItem('loginToken')
      this.userInfo = null
      this.isUserMenuOpen = false
    },
    handleViewHistory() {
      // Teacher page will auto-login via shared localStorage (same domain)
      window.location.href = '/teacher/history'
    },
    checkLoginStatus() {
      try {
        const tokenStr = localStorage.getItem('loginToken')
        if (tokenStr) {
          this.userInfo = JSON.parse(tokenStr)
        }
      } catch (e) {
        console.error('Failed to parse login token', e)
        localStorage.removeItem('loginToken')
      }
    }
  },
  mounted() {
    this.checkLoginStatus()
    // 点击外部关闭移动菜单
    document.addEventListener('click', (e) => {
      // Logic for mobile menu handled in template click handlers mostly, 
      // but this global listener was for the mobile menu specifically in original code
      if (this.$refs.navContainer && !this.$refs.navContainer.contains(e.target) && 
          !e.target.closest('.mobile-menu-btn')) {
         // this.isMobileMenuOpen = false // Keeping original logic if needed, but existing code handled it differently
      }
    })
  }
}
</script>

<style scoped>
.header {
  background: rgba(247, 247, 247, 0.5);
  backdrop-filter: blur(80px);
  -webkit-backdrop-filter: blur(80px);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.nav-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  position: relative;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.logo-img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.logo-text {
  font-size: 24px;
  font-weight: 700;
  color: #333D47;
}

/* 移动端汉堡菜单按钮 */
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 101;
}

.mobile-menu-btn span {
  width: 25px;
  height: 3px;
  background: #333D47;
  border-radius: 3px;
  transition: 0.3s;
  transform-origin: 1px;
}

.mobile-menu-btn.active span:first-child {
  transform: rotate(45deg);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
  transform: translateX(20px);
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: rotate(-45deg);
}

.nav-container {
  display: flex;
  justify-content: center;
  flex-grow: 1;
  margin-left: 0px;
}

.nav {
  display: flex;
  align-items: center;
  gap: 36px;
}

.nav-link {
  text-decoration: none;
  color: #333D47;
  font-weight: 500;
  transition: color 0.3s ease;
  white-space: nowrap;
}

.nav-link:hover,
.nav-link.router-link-active {
  color: #0D3A4A;
}

/* 登录按钮 */
.login-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(28, 60, 68, 1);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  margin-left: 20px;
  border: 2px solid #0D3A4A;
  box-shadow: 0 2px 8px rgba(13, 58, 74, 0.2);
}

.login-btn:hover {
  background: #1E4B5A;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(13, 58, 74, 0.3);
}

.login-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* User Profile Styles */
.user-profile {
  position: relative;
  margin-left: 20px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #3b82f6; /* Blue background */
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  user-select: none;
  transition: transform 0.2s;
}

.avatar:hover {
  transform: scale(1.05);
}

.user-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 189px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  z-index: 200;
  animation: fadeIn 0.15s ease-out;
  overflow: hidden;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: translateY(0); }
}

.menu-header {
  height: 63px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  box-sizing: border-box;
}

.menu-label {
  font-size: 12px;
  color: rgb(107, 114, 128);
  font-weight: 700;
}

.user-code {
  font-size: 14px;
  font-weight: 700;
  color: rgb(17, 24, 39);
}

.menu-item {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 16px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s;
  box-sizing: border-box;
}

.menu-item:hover {
  background-color: #f9fafb;
}

.menu-icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
}

.menu-icon {
  width: 24px;
  height: 24px;
}

.menu-item-content {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.menu-item-title {
  font-weight: 700;
  font-size: 14px;
  color: rgb(107, 114, 128);
  line-height: 1.5;
}

.menu-item-sub {
  font-size: 12px;
  color: rgb(156, 163, 175);
  font-weight: 400;
  line-height: 1.5;
}

/* 登录弹窗 */
.login-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.login-modal-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 66px 20px 20px;
  display: flex;
  justify-content: flex-end;
  /* pointer-events: none; REMOVED */
}

.login-modal-content {
  background: white;
  border-radius: 4px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 320px;
  max-width: 100%;
  overflow: hidden;
  /* pointer-events: auto; REMOVED */
}

.modal-header {
  padding: 8px 20px;
  background: rgba(55, 68, 102, 1);
  color: white;
}

.modal-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-logo-img {
  width: 32px;
  height: 32px;
  border-radius: 6px;
}

.modal-brand {
  font-size: 16px;
  font-weight: 500;
}

.modal-body {
  padding: 100px 20px;
  background: #F5F7FA;
}

.qrcode-container {
  text-align: center;
}

.qrcode-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.qrcode-border {
  width: 180px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.qrcode-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
}

.qrcode-text {
  font-size: 16px;
  color: #1a1a1a;
  font-weight: 400;
}

/* 移动端样式 */
@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }
  
  .login-btn {
    display: none;
  }
  
  .mobile-menu-btn {
    display: flex;
  }
  
  .nav-container {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    margin-left: 0;
    justify-content: flex-start;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
  
  .nav-container.mobile-open {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }
  
  .nav {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    width: 100%;
    padding: 20px;
  }
  
  .nav-link {
    padding: 12px 0;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 16px;
  }
  
  .nav-link:last-child {
    border-bottom: none;
  }
  
  .logo-text {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .logo-img {
    width: 40px;
    height: 40px;
  }
  
  .logo-text {
    font-size: 18px;
  }
  
  .container {
    padding: 0 12px;
  }
}
</style>